/** How long "New" tier-unlock badges stay visible after a plan upgrade. */
export const TIER_UNLOCK_BADGE_TTL_MS = 7 * 24 * 60 * 60 * 1000;

export function isTierUnlockBadgeWindowActive(
  activatedAt: string | undefined | null,
  nowMs: number = Date.now(),
): boolean {
  if (!activatedAt) return false;
  const activatedMs = Date.parse(activatedAt);
  if (!Number.isFinite(activatedMs)) return false;
  return nowMs - activatedMs < TIER_UNLOCK_BADGE_TTL_MS;
}
